module.exports = __webpack_public_path__ + "static/media/price1.cf45687d.png";